export function required(message: string) {
    return (v: any) => !!v || message;
}

export function minSize(min: number, message: string) {
    return (v: string) => !!v && v.length >= min || message;
}

export function equal(v2: () => any, message: string) {
    return (v1: any) => v1 === v2() || message;
}

export function email(message: string) {
    return (v: string) => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || message;
}

export function password(message: string) {
    return (v: string) => /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/.test(v) || message;
}



// WEBPACK FOOTER //
// ./resources/webapp/validations/index.ts